import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { TopMenuModule } from '@nk/app/top-menu/top-menu.module';
import { CountryFocusItemsModule } from '@nk/shared/components/country-focus-items/country-focus-items.module';
import { FeedbackModule } from '@nk/shared/components/feedback/feedback.module';
import { SiteWarningTopBannerComponent } from '@nk/shared/components/site-warning-top-banner/site-warning-top-banner.component';
import { ButtonDirective } from '@nk/ui-lib';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { AppFooterComponent } from './app-footer/app-footer.component';
import { AppHeaderComponent } from './app-header/app-header.component';
import { AppLayoutComponent } from './app-layout/app-layout.component';
import { MobileHeaderComponent } from './mobile-header/mobile-header.component';
import { SubNavigationComponent } from './sub-navigation/sub-navigation.component';

@NgModule({
  declarations: [
    AppLayoutComponent,
    AppHeaderComponent,
    SubNavigationComponent,
    AppFooterComponent,
    MobileHeaderComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    TopMenuModule,
    FeedbackModule,
    CountryFocusItemsModule,
    CollapseModule,
    TranslateModule,
    BsDropdownModule,
    ButtonDirective,
    SiteWarningTopBannerComponent,
  ],
  exports: [AppLayoutComponent],
})
export class WebPortalBlockModule {}
